import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowCircleUp16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowCircleUp16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m0 1A7 7 0 1 0 8 1a7 7 0 0 0 0 14m.509-8.845 1.974 1.975a.5.5 0 0 0 .707-.707L8.363 4.595 8.01 4.24l-.354.354-1.737 1.737-.77.77-.235.235-.064.064-.017.016-.004.005h-.001l.353.354-.353-.353a.5.5 0 1 0 .707.707l-.354-.354.354.354.001-.001.004-.005.017-.016.064-.064.235-.235.77-.77.884-.884v4.947a.5.5 0 0 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowCircleUp16);
